// extracted by css-extract-rspack-plugin
export default {"Box":"access-settings-view-module__Box__nGiCs","Heading":"access-settings-view-module__Heading__WRaEy"};